import BlogComponent from "../components/BlogComponent"
import Footer from "../components/footer"
import Header from "../components/header"

const BlogPage =()=>{
    return(
        <>
        {<Header/>}
        {<BlogComponent/>}
        
        </>
    )
}
export default BlogPage